export default function QueryVariables() {
    let query = window.location.search.substring(1);
    var vars = query.split('&');
    let returnObj = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        returnObj[pair[0]] = pair[1];
    }
    return returnObj;
}